import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { Router } from "@angular/router"
import * as $ from 'jquery';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-leaveReport',
    template: require('./leaveReport.component.html'),
    styles: [require('./leaveReport.component.css')],
    viewProviders: [ApiService]
})

export class leaveReportComponent implements OnInit {
    empDetails: any = [];
    check: string = "true";   
    status: any;
    empCode: string;
    fromDate: any;
    toDate: any;
    private columnDefs;
    private rowHeight;
    api: any;
    busy: Subscription;
    columnApi: any;
    defaultColDefine;
    private gridColumnApi;
    token:any;
    leaveForm = new FormGroup({
        fromDate: new FormControl(''),
        toDate: new FormControl(''),    
    });
    
    static parameters = [ApiService, Router]
    empData: any;
    constructor(private apiService: ApiService, private router: Router) {
        this.apiService = apiService;
        this.columnDefs = [
            { headerName: 'Employee Name', field: "Client_Name", suppressSizeToFit: true },
            { headerName: 'Manager', field: "manager" },
            { headerName: 'Date', field: "CreatedOn" },
            { headerName: 'Head Quarter', field: "HQName" },
            { headerName: 'Designation', field: "ClientTypeDesc" },
            {
                headerName: 'Status', field: "", width: 100, cellRenderer: function (params) {
                    var eDiv = document.createElement('div');
                    eDiv.innerHTML = (params.data.status == 1 ? `Approved` : params.data.status == 2 ? `Rejected` : `Pending`);
                    return eDiv
                }
            }
        ];
        this.rowHeight = 50;
        this.defaultColDefine = { resizable: true };
    }

    ngOnInit() {
        this.token = JSON.parse(sessionStorage.getItem("currentUser"));
        this.empCode = "0";
        this.status = "-1";
        var date = new Date();
        var year = date.getFullYear();
        var month = (date.getMonth() + 1).toString().padStart(2, "0");
        var firstDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        var lastDate = year + '-' + month + '-' + date.getDate().toString().padStart(2, "0");
        this.fromDate = firstDate;
        this.toDate = lastDate;
        this.leaveForm.controls['fromDate'].setValue(
            firstDate
        );
        this.leaveForm.controls['toDate'].setValue(
            lastDate
        );
        this.getEmployee();
        $('#filter-option').trigger('click');
    }

    getEmployee() {
        var data = {
            Id: this.token.id
        };
    this.apiService.getEmpDetails(data).subscribe((res: any) => {
            this.empData = res.data;
        })
    }

    onGridReady = (params) => {
        this.api = params.api;
        this.gridColumnApi = params.columnApi;
    }

    onBtnExport() {
        this.api.exportDataAsCsv({ fileName: 'employeemaster' });
    }

    sizeToFit(skipHeader) {
        var allColumnIds = [];
        this.gridColumnApi.getAllColumns().forEach(function (column) {
            allColumnIds.push(column.colId);
        });
        this.gridColumnApi.autoSizeColumns(allColumnIds, skipHeader);
    }

    onFilterTextBoxChanged() {
        this.api.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    }

    getEmpDetails() {
        let data = { empCode: this.empCode, fromDate: this.fromDate, toDate: this.toDate, 
            status: this.status,LoginId: this.token.id }
        console.log(data);
        this.busy = this.apiService.getLeaveReport(data).subscribe((res: any) => {
            this.empDetails = res.data;
        })
    }
}